<template>
  <!-- :class="[ isFullScreen ? 'flex h-screen items-center justify-center' : 'py-6' ]" -->
  <!-- <section class="main-section" :class="{'main-section-full flex h-screen items-center justify-center' : isFullScreen}"> -->
  <section
    class="main-section"
    :class="{'main-section-full' : isAsideMobileExpanded}"
  >
    <slot
      :departmentDefault="departmentDefault"
      :departmentListActive="departmentListActive"
      :academicDefault="academicDefault"
      :academicListActive="academicListActive"
      :levelDefault="levelDefault"
      :levelListActive="levelListActive"
      :semesterDefault="semesterDefault"
      :semesterListActive="semesterListActive"
      :subjectListActive="subjectListActive"
    />
  </section>
</template>

<script>
  /* eslint-disable */
  import { computed } from 'vue'
  import { useStore } from 'vuex'

  export default {
    props: {
      departmentDefault: { type: String, default: "" },
      departmentListActive: { type: Array, default: () => [] },
      academicDefault: { type: String, default: "" },
      academicListActive: { type: Array, default: () => [] },
      levelDefault: { type: String, default: "" },
      levelListActive: { type: Array, default: () => [] },
      semesterDefault: { type: String, default: "" },
      semesterListActive: { type: Array, default: () => [] },
      subjectListActive: { type: Array, default: () => [] }
    },

    setup( props, { emit } ) {
      const store = useStore()
      // const isFullScreen = computed(() => store.state.isFullScreen)
      const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)

      return {
        isAsideMobileExpanded
      }
    }
  }
</script>
